<template>
<div class="select_box_dropdown_container">
  <div class="select_downdown_icon" @click="dropClick">Table Display Options</div>
  <ul class="select_box_dropdown" v-show="dropdownDisplayed">
    <li :class="{ selection_mode_option_active: selectionBoxMode === 'Communities' }" class="select_box_dropdown_option" @click="modeSelection('Communities')">Communities</li>
    <li :class="{ selection_mode_option_active: selectionBoxMode === 'AEA Energy Regions' }" class="select_box_dropdown_option" @click="modeSelection('AEA Energy Regions')">AEA Energy Regions</li>
    <li :class="{ selection_mode_option_active: selectionBoxMode === 'Census Areas' }" class="select_box_dropdown_option" @click="modeSelection('Census Areas')">Census Areas</li>
  </ul>
</div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'select-box-dropdown',
  data: function () {
    return {
      dropdownDisplayed: false
    }
  },
  computed: mapState([
    'selectionBoxMode'
  ]),
  methods: {
    dropClick: function () {
      this.dropdownDisplayed = !this.dropdownDisplayed
    },
    modeSelection: function (mode) {
      if (this.selectionBoxMode !== mode) {
        this.$store.commit({
          type: 'communitySelectionModeChange',
          mode: mode
        })
      }
      this.dropdownDisplayed = false
    }
  }
}
</script>
<style>
.select_box_dropdown_container {
  position: relative;
  cursor: pointer;

}

.select_box_dropdown {
  position: absolute;
  top: 1rem;
  right: 0;
  width: 10rem;
  /*margin: 0;*/
  background-color: white;
  box-shadow: 0px 5px 5px grey;
}

.select_box_dropdown_option {
  padding: .5rem 0 .5rem .5rem;
  width: 100%;
}

.select_box_dropdown_option:hover {
  background-color: #43A047;
}

.selection_mode_option_active {
  background-color: #1E88E5;
}
</style>



// WEBPACK FOOTER //
// SelectBoxDropdown.vue?e87df138